export default __webpack_public_path__ + "static/media/16.7fedd8c6.jpg";